import { cn } from '@repo/tailwind-config/tailwind.functions'
import RadioInput from '@repo/ui/radio-input'
import Typography from '@repo/ui/typography'

import { LanguageTestQuestion } from '../../../../lib/types/models/language-test/language-test-question'
import useLanguageTest from '../../../../views/client-personal-space/informations/context/use-language-test'

interface LanguageTestQuestionsProps {
  questions: (Pick<LanguageTestQuestion, 'id' | 'label' | 'position' | 'annotatedPosition'> & {
    answers: Pick<LanguageTestQuestion['answers'][number], 'id' | 'label' | 'position'>[]
  })[]
  subTitle?: string | React.ReactNode
}

const LanguageTestQuestions = ({ questions, subTitle }: LanguageTestQuestionsProps) => {
  const { responses, saveResponse } = useLanguageTest()

  return (
    <div className="flex flex-col gap-4">
      {typeof subTitle === 'string' ? (
        <Typography variant="secondary-body">{subTitle}</Typography>
      ) : (
        subTitle
      )}

      {questions?.map((question, index) => (
        <div key={question.id} className="border border-red-light rounded-lg p-4">
          <div className="space-y-4">
            <div className="flex items-baseline gap-3">
              <Typography
                variant={question.annotatedPosition ? 'label-semibold' : 'caption'}
                className={cn(
                  'flex-shrink-0 w-8 h-8 bg-transparent text-red border border-red-light rounded-full flex items-center justify-center',
                  question.annotatedPosition && 'w-12 h-12'
                )}
              >
                {question.annotatedPosition ?? index + 1}
              </Typography>
              <div className="flex-1">
                <Typography
                  variant="secondary-body"
                  className="select-none"
                  onCopy={(e) => e.preventDefault()}
                  onCut={(e) => e.preventDefault()}
                >
                  {question.label}
                </Typography>

                <div className="space-y-2 mt-4">
                  {question.answers?.map((answer) => (
                    <RadioInput
                      key={answer.id}
                      label={answer.label}
                      labelClassName="select-none"
                      checked={responses.get(question.id) === answer.id}
                      onCheck={() => saveResponse(question.id, answer.id)}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default LanguageTestQuestions
